import { icons } from "assets/icons";
import { Horizontal, Vertical } from "gls/lib";
import { isString } from "lodash";
import Collapsible from "react-collapsible";
import { colours } from "styling/colours";
import { style, stylesheet } from "typestyle";
import { IdNamePair, IdTextPair } from "utils/common";
import { formatNumericValue } from "utils/numeric";

type CollapsibleListProps = {
  label: string;
  items: IdTextPair<string>[] | IdNamePair<string>[] | string[];
  boldErrors?: boolean;
}
export const CollapsibleList = ({ label, items, boldErrors = true }: CollapsibleListProps) => {

  return (
    <Collapsible
      triggerClassName={PanelStyle.trigger}
      triggerOpenedClassName={PanelStyle.openTrigger}
      trigger={
        <Horizontal spacing={10} role="button" tabIndex={0}>
          <span>{label} ({formatNumericValue(items.length)})</span>
          <icons.ArrowDownIcon aria-label="expand" height={10} width={10} />
        </Horizontal>
      }>
      <Vertical spacing={10} className={itemsStyle}>
        <ul>
          {items.map((r, index) => boldErrors
            ? <li><b key={`collapse-item-${index}`}>{isString(r) ? r : ("text" in r ? r.text : r.name)}</b></li>
            : <li><span key={`collapse-item-${index}`}>{isString(r) ? r : ("text" in r ? r.text : r.name)}</span></li>
          )}
        </ul>
      </Vertical>
    </Collapsible>
  )
}

const PanelStyle = stylesheet({
  trigger: {
    color: colours.primaryText,
    textDecoration: 'underline',
    textUnderlineOffset: '4px',
    $nest: {
      "& svg": {
        marginTop: "4px"
      },
      ".is-open": {
        $nest: {
          "&::after": {
            transform: 'rotateZ(180deg)',
          }
        }
      },
    }
  },
  openTrigger: {
    display: 'block',
    paddingBottom: '10px',
    textDecoration: 'underline',
    textUnderlineOffset: '4px',
    color: colours.primaryText,
    $nest: {
      "& svg": {
        marginTop: "4px",
        transform: "rotateZ(-90deg)"
      }
    }
  }
})

const itemsStyle = style({
  color: colours.primaryText,
  $nest: {
    "li": {
      marginBottom: '10px'
    }
  }
})